import React, { Component } from 'react';

import {
    Title,
    Grid,
    Image,
    Row,
} from 'yurstrap';

import illuMailSent from '../../../../../images/support/illu__mail--sent.svg';

class ContactSalesmanSuccess extends Component {

    render() {
        return (
            <div className="contact-form-front--bg">
                <Grid size="small" className="contact-form-front u-bg__white" style={{ minHeight: '720px' }}>
                    <Row
                        vcenter
                        noCol
                        style={{ height: '720px' }}
                    >
                        <div className="u-col-12 u-text-align__center">
                            <Image
                                alt="Mail has been sent illustration"
                                size="m"
                                className="mb-3 mx-a"
                                src={illuMailSent}
                            />
                            <Title className="u-color__success--darker">
                                Message envoyé !
                            </Title>
                            <p className="u-font-size--3 u-color__grey--dark">
                                Votre demande a bien été prise en compte !
                                <br />
                                Un conseiller y répondra sous 24h ouvrées.
                            </p>
                        </div>
                    </Row>
                </Grid>
            </div>
        );
    }

}

export default ContactSalesmanSuccess;
